import React from 'react';
import ReactDOM from 'react-dom';
import DataTable from '@/components/common/DataTable';
import { queryClient, ReactQueryProvider } from '@/utils/ReactQuery';
import EditGlossaryTermModal from '@/components/admin/GlossaryTerms/EditGlossaryTermModal';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useTableGlossaryTerms } from './GlossaryTermTable.utils';
import DeleteGlossaryTermButton from '../GlossaryTerms/DeleteGlossaryTermButton';

const GlossaryTermsTable = ({ lessonNumber, lessonTitle, sectionId }) => {
  const { data, isLoading, isFetching, queryKey } = useTableGlossaryTerms({ sectionId: sectionId.toString() });

  const columns = [
    {
      name: 'term',
      sortable: false,
      targets: 0,
      title: 'Term',
    },
    {
      createdCell: (td, _, rowData) => {
        ReactDOM.render(<img alt={rowData.term} src={rowData.thumbnail_url} />, td);
      },
      name: 'thumbnail_url',
      sortable: false,
      targets: 1,
      title: 'Image',
    },
    {
      name: 'definition',
      sortable: false,
      targets: 2,
      title: 'Definition',
    },
    {
      name: 'example_sentence',
      sortable: false,
      targets: 3,
      title: 'Example Sentence',
    },
    {
      name: 'kind',
      sortable: false,
      targets: 4,
      title: 'Type',
    },
    {
      createdCell: (td, _, rowData) => {
        const onSuccess = () => {
          queryClient.invalidateQueries(queryKey);
          queryClient.invalidateQueries(['glossaryTerms']);
        };
        ReactDOM.render(
          <ReactQueryProvider>
            <div className="tw-flex tw-gap-1">
              <EditGlossaryTermModal
                glossaryTerm={rowData}
                initialValues={rowData}
                sectionId={rowData.section_id}
                onSuccess={onSuccess}
              />
              <DeleteGlossaryTermButton
                glossaryTerm={rowData}
                lessonNumber={lessonNumber}
                lessonTitle={lessonTitle}
                onSuccess={onSuccess}
              />
            </div>
          </ReactQueryProvider>,
          td,
        );
      },
      name: 'actions',
      sortable: false,
      targets: 5,
      title: 'Actions',
    },
  ];

  return (
    <>
      <ReactQueryDevtools />
      <DataTable
        handleResourcesManually
        columnDefs={columns}
        columns={columns.map(c => c.name)}
        isLoading={isLoading || isFetching}
        paging={false}
        resources={data}
      />
    </>
  );
};

export default GlossaryTermsTable;
